import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const skeletonVariants = cva("bg-accent", {
    variants: {
        variant: {
            line: "animate-pulse rounded-md",
            thumbnail: "rounded",
        },
    },
    defaultVariants: {
        variant: "line",
    },
});

function Skeleton({
    className,
    variant,
    ...props
}: React.ComponentProps<"div"> & VariantProps<typeof skeletonVariants>) {
    return <div data-slot="skeleton" className={cn(skeletonVariants({ variant }), className)} {...props} />;
}

export { Skeleton, skeletonVariants };
